import axios from "axios";

export function createApiClient(getToken) {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE,
  });

  api.interceptors.request.use(async (config) => {
    const token = await getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  return api;
}
